var MultiselectExt = new Class({
	Extends: Multiselect,

	build: function(){
		this.parent();

		this.set_nh_coordinates();
		this.add_toggle();
		this.add_close_button();
		this.move_aces();
		this.group_elements();
		this.move_fidi_and_bpc();
	},

	set_nh_coordinates: function(){
		this._children.each(function(_el, i){
			var _coords = _el.getElement('.hoods_coordinates');

			if(_coords){
				_el.region_coords = JSONMOO.decode(_coords.get('html'), false);
			}else{
				var _checkbox = _el.getElement('input[type="checkbox"]');
				var id = (_checkbox? _checkbox.get('value') : null);

				if(id && _el._master.region_coords){
					_el.coords = _el._master.region_coords[id];
				}
			}
		});
	},

	add_map: function(){
		var self = this;
		var opts = this.options;

		this._map_cont = new Element('div', {'class': opts.cls + '_map_cont'}).inject(this._list_cont);
		this._map_veil = new Element('div', {'class': opts.cls + '_map_veil'}).inject(this._map_cont);
		this._map = new Element('div', {'class': opts.cls + '_map w_neighborhoods_map'});

		this.regions_map = new RegionsMap(this._map, {
			min_zoom: 11,
			max_zoom: 14,
			add_lazy_load: false,
			style: 'light',
			onMapReady: function(m){
				self._map.inject(self._map_cont);

				var __select_slaves_regions = function(_el){
					var _slaves = _el._slaves;

					if(!_slaves || _slaves.length == 0) return;

					_slaves.each(function(_e){
						if(_e._slaves){
							__select_slaves_regions(_e);
						}

						if(_e.map_region){
							(function(){
								if(_el.hasClass('_selected')){
									self.regions_map.select_region(_e.map_region);
								}else{
									self.regions_map.deselect_region(_e.map_region);
								}
							}).delay(50);
						}
					});
				}

				self._children.each(function(_el, i){
					if(!_el.coords){
						_el.addEvent('click', function(){
							__select_slaves_regions(_el);
						});

						return;
					}

					var name = _el.getElement('span').get('text');
					var region;

					_el.addEvent('click', function(){
						if(region.selected){
							self.regions_map.deselect_region(region);
						}else{
							self.regions_map.select_region(region);
						}
					});

					var __region_on_click = function(){
						_el.fireEvent('click');
					}

					region = _el.map_region = m.set_region(name, _el.coords, __region_on_click, _el.hasClass('_selected'));
				});

				self._map_veil.hide();

				self.show_map();
			}
		});
	},

	add_toggle: function(){
		var self = this;

		this._toggle = new Element('ul', {'class': 'w_toggle _template', 'html': '<li class="list _selected"><i class="fa fa-list"></i>List</li><li class="map"><i class="fa fa-map-marker big"></i>Map</li>'});

		this._toggle.inject(this._element, 'top');

		var toggle = new Toggle(this._toggle);

		toggle.addEvents({
			'toggle': function(e){
				self.open_list();

				if(e.hasClass('map')){
					if (!self.regions_map) {
						self.add_map();
					} else {
						self.show_map();
					}
				}else{
					self.hide_map();
				}

				self.limousine.clear_results();
				self.limousine._field.set('value', '');
				self.limousine._field.show();
				self.limousine._field.focus();
			}
		});
	},

	show_map: function(){
		this._element.addClass('show_map');

		google.maps.event.trigger(this.regions_map.map, 'resize');

		this.regions_map.set_zones();
	},

	hide_map: function(){
		this._element.removeClass('show_map');
	},

	move_aces: function(){
		var _joker = this._list.getElement('.joker');
		var _aces = this._list.getElements('.ace');

		var _inject_after = _joker;

		_aces.each(function(_el){
			_el.inject(_inject_after, 'after');

			_inject_after = _el;
		});
	},

	hover_element: function(_el, action){
		if(_el.hasClass('king')){
			var _parent = _el.getParent('.group');

			if(action){
				_parent.addClass('_hovered');
			}else{
				_parent.removeClass('_hovered');
			}
		}
	},

	group_elements: function(){
    var _group, _ul;

    this._element.getElements('li').each(function(_el){
      if(_el.hasClass('joker') || _el.hasClass('king')){
        _group = new Element('li', {'class': 'group' + (_el.hasClass('joker')? ' _main' : '')}).inject(_el, 'before');

        if(_el.hasClass('king')){
        	_group.addClass(_el.get('class'));
        	_group.removeClass('king');
        }

        _ul = new Element('ul.clearfix').inject(_group).adopt(_el);
      }

      if(_el.hasClass('ace') || _el.hasClass('queen')){
        _el.inject(_ul);
      }
    });
	},

	move_fidi_and_bpc: function(){
		var _fdb = this._element.getElement('.group.fdb');

		if(_fdb && !this._element.getParent('.w_miniquest._small')){
			_fdb.inject(_fdb.getParent());
		}
	}
});
